// extracted by mini-css-extract-plugin
module.exports = {"merch":"keto-merch_merch__v4lG_","merch_inner":"keto-merch_merch_inner__bv1nE","merch_title":"keto-merch_merch_title__1Vm9E"};